import { About } from 'components/About';

export const AboutPage = (): JSX.Element => {
    return (
        <>
            <About></About>
        </>
    );
}